export enum AuthApplicationIds {
    PetPass = 1,
    SWIFT = 2,
    Admin = 3
}
